import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AboutUsComponent } from './about-us/about-us.component';
import { InfoComponent } from './info/info.component';
import { SuccessInfoComponent } from './shared/success-info/success-info.component';
import {DonationComponent} from './donation/donation-info/donation.component';
import {DonationSuccessComponent} from "./donation/donatio-return-url/donation-success.component";
import {DonationFailComponent} from './donation/donatio-return-url/donation-fail.component';
import {DonationCancelComponent} from "./donation/donatio-return-url/donation-cancel.component";
import {PrivacyComponent} from './privacy/privacy.component';
import { HomePageComponent } from './payment/home-page/home-page.component';
import {GalleryComponent} from './gallery/gallery.component';
import {PartnersComponent} from './partners/partners.component';

const routes: Routes = [
  // { path: '', redirectTo: '/home/electricity-bill', pathMatch: 'full' },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomePageComponent },
  // { path: 'home', redirectTo: '/home/electricity-bill', pathMatch: 'full' },
  { path: 'payment', pathMatch: 'prefix', loadChildren: './payment/payment.module#PaymentModule' },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'donation', component: DonationComponent },
  { path: 'donation/success', component: DonationSuccessComponent },
  { path: 'donation/fail', component: DonationFailComponent },
  { path: 'donation/cancel', component: DonationCancelComponent },
  // { path: 'about-us', component: AboutUsComponent },
  { path: 'gallery', component: GalleryComponent },
  // { path: 'partners', component: PartnersComponent },
  { path: 'info', component: InfoComponent },
  { path: 'success-info', component: SuccessInfoComponent },
  { path: 'payment', pathMatch: 'prefix', loadChildren: './payment/payment.module#PaymentModule' },
  { path: 'bill-payment', pathMatch: 'prefix', loadChildren: './payment/payment.module#PaymentModule' },
  { path: 'dedicated-biller', pathMatch: 'prefix', loadChildren: './dedicated-biller/dedicated-biller.module#DedicatedBillerModule' },
  { path: 'user', pathMatch: 'prefix', loadChildren: './user/user.module#UserModule' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts